module.exports = __webpack_public_path__ + "img/p19_03.e29e68e0.png";